/**
 * 设备管理-学生课桌管理接口
 */
import request from '@/utils/request';

// 学生课桌列表查询
function queryDesks(option) {
  return request({
    url: `/op/studentdesks/list`,
    method: 'get',
    params: option
  });
}

// 查看学生课桌详情查询
function queryDeskDetail(option) {
  return request({
    url: `/op/studentdesks/${option.id}`,
    method: 'get'
  });
}

export default {
  queryDesks,
  queryDeskDetail
};
